var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"errormessage",class:_vm.noText ? 'notext' : ''},[_vm._v(" "+_vm._s(_vm.errortext ? _vm.errortext : '텍스트가없습니다')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }